module.exports = __webpack_public_path__ + "img/home-removebg-preview.133ad8d9.png";